import Vue from 'vue'
import VueRouter from 'vue-router'
import UserLogin from '@/views/UserLogin.vue'
import { currentUser, Bus } from '@/utils/baaSApi'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'userLogin',
    component: UserLogin
  },
  {
    path: '/home',
    name: 'userHome',
    component: () => import(/* webpackChunkName: "UserHome" */ '@/views/UserHome.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  currentUser().then((user) => {
    if (user.code == 200) {
      Bus.set('clname', user.data.get('clname'))
      if (to.name == 'userLogin') next({ name: 'userHome' })
      else next()
    } else {
      Bus.set('clname', { id: '', name: '' })
      if (to.name == 'userLogin') next()
      else next({ name: 'userLogin' })
    }
  })
})

export default router